import React, { Component } from 'react'
import './css/navbar.css'
export default class sublist_services extends Component {
    render() {
        return (
            <div>
                  <div className='sublist-services'>
                        <ul>
                            <li><a href="/services/consulting">Strategy and Organization</a></li>
                            <li><a href="/services/learning">Learning</a></li>
                            <li><a href="/services/eventmanagement">Event management</a></li>
                            <li><a href="/services/assesment">Assesment</a></li>
                            <li><a href="/services/digitallearning">Digital learning</a></li>
                        </ul>
                    </div>
            </div>
        )
    }
}
